import { Logger } from "./Logger";

/**
 * Check and validate the browser can write and read in the localStorage
 */
export function validateWritingLocalStorage(): boolean {
  let canWriteLocalStorage = true;
  const key = "isd-writing-test";
  const value = "test";

  try {
    localStorage.setItem(key, value);
    const storedValue = localStorage.getItem(key);
    if (storedValue !== value) {
      canWriteLocalStorage = false;
      Logger.warn(`Unable to write/read in local storage.`);
    }
    localStorage.removeItem(key);
  } catch (e) {
    Logger.warn(`Unable to write/read in local storage. Error: ${e}.`);
    canWriteLocalStorage = false;
  }

  return canWriteLocalStorage;
}
